// Project discovery moved to @kenkaiiii/ggcoder (one home — also used by the
// gg-app sidecar). Re-exported here so existing `./discover.js` imports keep
// resolving unchanged.
export { discoverProjects, type DiscoveredProject, type ProjectSource } from "@kenkaiiii/ggcoder";
